import { ConvexReactClient } from 'convex/react'

// Use the Convex URL from environment variable
const convexUrl = process.env.REACT_APP_CONVEX_URL

// Validate that Convex URL is configured
if (!convexUrl) {
	console.error('REACT_APP_CONVEX_URL is not configured. Please set it in your .env file.')
	// In development, you can fall back to localhost
	if (process.env.NODE_ENV === 'development') {
		console.warn('Falling back to localhost for development')
	} else {
		throw new Error('REACT_APP_CONVEX_URL must be configured for production')
	}
}

// Initialize Convex client (simple - no auth setup needed)
export const convex = new ConvexReactClient(convexUrl || 'http://127.0.0.1:3210')

// Helper to get JWT token for Convex calls
export function getConvexToken() {
	return localStorage.getItem('jwtToken') || ''
}
